import { mergeClasses } from "@griffel/react";
export const menuGroupClassNames = {
  root: 'fui-MenuGroup'
};
export const useMenuGroupStyles_unstable = state => {
  state.root.className = mergeClasses(menuGroupClassNames.root, state.root.className);
  return state;
};